module.exports = __webpack_public_path__ + "img/Betting_text04_pressJK.457eceb9.png";